import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { CreateHeaderPopupComponent } from './create-header-popup/create-header-popup.component';
import { CreateRecordsPopupComponent } from './create-records-popup/create-records-popup.component';

import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { MappingtypePopupScreenComponent } from '../mappingtype/mappingtype-popup-screen/mappingtype-popup-screen.component';
import { Router } from '@angular/router';
import { ActionwithcheckboxComponent } from 'src/app/shared/common/Actionwithcheckbox';

import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';

import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { ExceljsServiceService } from 'src/app/shared/services/exceljs-service.service';


@Component({
    selector: 'app-field-mapping',
    templateUrl: './field-mapping.component.html',
    styleUrls: ['./field-mapping.component.scss'],
    standalone: false
})
export class FieldMappingComponent implements OnInit {
  navLinks = [
    {
      label: 'Objects',
      link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
      index: 0
    },
    {
      label: 'Stage Objects',
      link: 'stageobject',
      index: 1
    },
    {
      label: 'Objects Mapping',
      link: 'mappingconfiguration',
      index: 1
    },
    {
      label: 'Attributes Mapping',
      link: 'attributemappingconfig',
      index: 1
    },
    {
      label: 'Value Mapping',
      link: 'fieldMapping',
      index: 1
    },
     {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
      
  ];
  buttonColor;
  backgroundColorScreen;
  validations_form: UntypedFormGroup;
  selectedMappingType;
  mappingTypeData;

  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData:any[]=[];
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  currentpage;
  totalpages;
  lastpage;
  nextpage;
  getdata;
  importExportTableName = "field_mapping";
  components: any;
  headersDataDetails = {
    "SourceColumns": [],
    "TargetColumns": []
  }
  columnDefinitions = []
  selectedHeadersDetails = []
  buttonName = "Create Mapping"
  selectedValueMappingIndexs: any = []
  buttonIdList = []
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private constants: constants, private commonService: CommonService,
    private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,
    private msg: ErrorMessages,
    private validation: validationmethod,
    private dialog: MatDialog,
    private service: FieldMappingService,
    private router: Router,
    private userRoutingModule: UserRoutingModule,
    private reportLinkService: ReportlinksserviceService,
    private excelService: ExceljsServiceService
  ) {
    this.components = {
      // buttonRenderer: Actionbutton,
      buttonRenderer: ActionwithcheckboxComponent,
    }
  }

  ngOnInit(): void {
    this.hasPermission()
    this.retrieveMappingTypes()
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.formValidation()

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

  }

  formValidation() {
      
    this.validations_form = new UntypedFormGroup({
  
      mappingType: new UntypedFormControl('', [Validators.required])
    });
      
  }
  retrieveMappingTypes() {
    this.spinner.start();
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.service.retreiveMappingTypes(dnsId).subscribe(response => {
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        console.log(response);
        this.mappingTypeData = response;
        this.spinner.stop();
      }
    })
  }
 

  onBtExport() {
    this.gridAPI.api.exportDataAsCsv();
  }
  onSearchChange(searchValue: number) {
    this.gridAPI.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.api.paginationGoToLastPage();
  }

  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastpage = this.gridAPI.api.paginationIsLastPageFound();
      this.currentpage = this.gridAPI.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridAPI.api.paginationGetTotalPages()
    }
  }

  onGridReady(params) {
    this.gridAPI = params;
    this.gridAPI.api.setGridOption('rowData', [])
    //  this.gridAPI.api.hideOverlay();

  // optional: show no rows message
  this.gridAPI.api.showNoRowsOverlay();
  }

 

  onMappingTypeSelectionChange() {
    if (this.selectedMappingType != 'AddLibrary') {
      this.spinner.start();
      this.selectedHeadersDetails = []
      this.headersDataDetails = {
        "SourceColumns": [],
        "TargetColumns": []
      }
      this.rowData = []
      this.columnDefinitions = []
      this.service.retreiveFieldMapping(this.selectedMappingType).subscribe(response => {
        if (response.error == true) {
          this.spinner.stop();
          this.getdata = null
          this.rowData = []
          console.log(this.getdata)
          this.gridAPI.api.setGridOption('rowData', this.getdata)
          this.gridAPI.api.hideOverlay();
          this.columnDefs = [];
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        } else {
          console.log(response);
          // this.mappingTypeData=response;
    
          this.getdata = response
        
          let data: any = JSON.parse(this.getdata.mappedFieldsData)
          if (data) {
            let indexData = data.map((item, i) => ({
              index: i,
              ...item
            }));
            this.getdata.mappedFieldsData = JSON.stringify(indexData)
          }
          console.log(data);
          console.log(this.getdata)
          let headers = JSON.parse(this.getdata.mappedFields)
          console.log("header--->",headers)

  
if (!headers) {
  this.headersDataDetails = {
    SourceColumns: [],
    TargetColumns: []
  };
} else {
  this.headersDataDetails = headers;
}
const selected = this.mappingTypeData?.find(
  x => x.mappingTypeId === this.selectedMappingType
);
console.log("Selected Mapping Type:", selected);
const required_mappingName = this.constants.CODELIST_MAPPING_NAME;
if (selected?.mappingTypeName === required_mappingName) {
  this.addMandatoryHeadersIfMissing();

   this.selectedHeadersDetails = [
    ...this.headersDataDetails.SourceColumns,
    ...this.headersDataDetails.TargetColumns
  ];
   console.log("header  --->", this.selectedHeadersDetails)

}

if (this.getdata?.mappedFieldsData) {
  let rows = JSON.parse(this.getdata.mappedFieldsData);

  const mandatoryLabels = this.constants.CODELIST_MANDATORY_HEADERS
    .map(h => h.label);

  rows = rows.map(row => {
    mandatoryLabels.forEach(col => {
      if (!(col in row)) {
        row[col] = '';
      }
    });
    return row;
  });

  this.getdata.mappedFieldsData = JSON.stringify(rows);
}

headers = {
  SourceColumns: [...this.headersDataDetails.SourceColumns],
  TargetColumns: [...this.headersDataDetails.TargetColumns]
};


          if (headers) {
            this.hasPermission()
            console.log(headers);
            this.selectedHeadersDetails = []
            this.columnDefinitions = []
            let actionButtons = {
              headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
              pinned: 'left',
              lockPinned: true,
              cellRendererParams: {
                values: this.buttonIdList,
                 showView: false,
                edit: this.EditIcon.bind(this),
                delete: this.deleteIcon.bind(this),
                onCheckboxChange: this.checkIcon.bind(this)
              }, width: 150
            }
            this.columnDefinitions.push(actionButtons)
            // this.onGridReady(this.gridApi);
            this.selectedHeadersDetails.push(...headers.SourceColumns)
            this.selectedHeadersDetails.push(...headers.TargetColumns)
            this.headersDataDetails = headers
            console.log(this.headersDataDetails);
 
            for (let i = 0; i < this.headersDataDetails.SourceColumns.length; i++) {
              let columnDef = {
                headerName: this.headersDataDetails.SourceColumns[i].label,
                field: this.headersDataDetails.SourceColumns[i].label,
                width: 180,
                filter: true,
                suppressToolPanel: true,
                headerTooltip: this.headersDataDetails.SourceColumns[i].label,
                tooltipValueGetter: (params: any) => params.value,
                align: 'center'
              }
              this.columnDefinitions.push(columnDef)
            }
            for (let i = 0; i < this.headersDataDetails.TargetColumns.length; i++) {
              let columnDef = {
                headerName: this.headersDataDetails.TargetColumns[i].label,
                field: this.headersDataDetails.TargetColumns[i].label,
                width: 180,
                filter: true,
                cellStyle: { backgroundColor: '#a0b4c34a' },
                headerClass: 'header-cyan',
                suppressToolPanel: true,
                headerTooltip: this.headersDataDetails.TargetColumns[i].label,
                tooltipValueGetter: (params: any) => params.value,
                align: 'center'
              }
              this.columnDefinitions.push(columnDef)
            }
           // this.columnDefs = this.columnDefinitions;
           this.columnDefs = [...this.columnDefinitions];
           this.gridAPI.api.setGridOption('columnDefs', this.columnDefs);
this.gridAPI.api.refreshHeader();
this.gridAPI.api.refreshCells();
            console.log(this.columnDefs);
          
            
          }
          if (this.getdata.mappedFieldsData != null) {
            this.rowData = JSON.parse(this.getdata.mappedFieldsData)
            this.gridAPI.api.setGridOption('rowData', JSON.parse(this.getdata.mappedFieldsData))
            this.gridAPI.api.hideOverlay();
            this.buttonName = "Update Mapping"
          } else {
            this.rowData = []
             console.log("column def---->",this.columnDefs);
             if (selected?.mappingTypeName === required_mappingName) {
                  this.columnDefs = [...this.columnDefinitions];
                 this.gridAPI.api.setGridOption('columnDefs', this.columnDefs);
                  this.gridAPI.api.refreshHeader();
                  this.gridAPI.api.refreshCells();             }
             else{
            this.columnDefs = [];
            this.gridAPI.api.setGridOption('rowData', [])
            this.gridAPI.api.showNoRowsOverlay();
             }
            this.buttonName = "Create Mapping"
          }
          this.spinner.stop();
        }
      })
    } else {
      this.selectedMappingType = ""
      console.log(this.validations_form.get('mappingType'));
      this.validations_form.reset();
      this.validations_form.get("mappingType").markAsUntouched();
      this.openSaveForm('save')
    }
  }

  openSaveForm(buttonName) {
    this.buttonName = buttonName;
     
    let width = '80%';
    var obj = {}
    let dialogRef = this.dialog.open(MappingtypePopupScreenComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '60%',
      autoFocus: false,
      data: { edata: obj },
      disableClose: true,
    });
  
    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      //  this.retrieveAssignUsersRoleByDnsId();
      this.retrieveMappingTypes()
      
    });
      
  }
  EditIcon(event) {
    console.log(event);
    let dialogRef = this.dialog.open(CreateRecordsPopupComponent, {
      width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      disableClose: true,
      data: { editData: this.headersDataDetails, editRowData: event.rowData },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        console.log(result);
        console.log(this.rowData[result.index]);
        console.log(this.rowData);
        
        this.rowData[result.index] = result
        // this.rowData=result
        this.gridAPI.api.setGridOption('rowData', this.rowData)
        this.gridAPI.api.hideOverlay();
      }
    });

  }
  deleteIcon(event) {
    console.log(event.rowData);
    this.rowData.splice(event.rowData.index, 1)
    for (let i = 0; i < this.rowData.length; i++) {
      this.rowData[i].index = i
    }
    this.gridAPI.api.setGridOption('rowData', this.rowData)
    this.gridAPI.api.hideOverlay();
  }
  createHeaders() {
    console.log(this.selectedHeadersDetails);
    
    let dialogRef = this.dialog.open(CreateHeaderPopupComponent, {
      width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      disableClose: true,
      data: { editData: this.selectedHeadersDetails },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
       
        
        this.selectedHeadersDetails = []
        this.headersDataDetails = {
          "SourceColumns": [],
          "TargetColumns": []
        }
        this.columnDefinitions = []
        let actionButtons = {
          headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
          pinned: 'left',
          lockPinned: true,
          cellRendererParams: {
            edit: this.EditIcon.bind(this),
            delete: this.deleteIcon.bind(this),
            onCheckboxChange: this.checkIcon.bind(this)
          }, width: 150
        }
        this.columnDefinitions.push(actionButtons)
        // this.onGridReady(this.gridApi);
        this.selectedHeadersDetails = result
        for (let i = 0; i < this.selectedHeadersDetails.length; i++) {
          if (this.selectedHeadersDetails[i].sourceOrTarget == "Source") {
            let headerObject = {
              "label": this.selectedHeadersDetails[i].label,
              "datatype": this.selectedHeadersDetails[i].datatype,
              "sourceOrTarget": this.selectedHeadersDetails[i].sourceOrTarget,
              "keyOrder": this.selectedHeadersDetails[i].keyOrder,
              "isMandatory": this.selectedHeadersDetails[i].isMandatory
            }
            this.headersDataDetails.SourceColumns.push(headerObject)
          } else {
            let headerObject = {
              "label": this.selectedHeadersDetails[i].label,
              "datatype": this.selectedHeadersDetails[i].datatype,
              "sourceOrTarget": this.selectedHeadersDetails[i].sourceOrTarget,
              "keyOrder": this.selectedHeadersDetails[i].keyOrder,
              "isMandatory": this.selectedHeadersDetails[i].isMandatory
            }
            this.headersDataDetails.TargetColumns.push(headerObject)
          }
        }
        console.log(this.headersDataDetails);
        for (let i = 0; i < this.headersDataDetails.SourceColumns.length; i++) {
          let columnDef = {
            headerName: this.headersDataDetails.SourceColumns[i].label,
            field: this.headersDataDetails.SourceColumns[i].label,
            width: 180,
            filter: true,
            suppressToolPanel: true,
            headerTooltip: this.headersDataDetails.SourceColumns[i].label,
            tooltipValueGetter: (params: any) => params.value,
            align: 'center'
          }
          this.columnDefinitions.push(columnDef)
        }
        for (let i = 0; i < this.headersDataDetails.TargetColumns.length; i++) {
          let columnDef = {
            headerName: this.headersDataDetails.TargetColumns[i].label,
            field: this.headersDataDetails.TargetColumns[i].label,
            width: 180,
            filter: true,
            cellStyle: { backgroundColor: '#a0b4c34a' },
            headerClass: 'header-cyan',
            suppressToolPanel: true,
            headerTooltip: this.headersDataDetails.TargetColumns[i].label,
            tooltipValueGetter: (params: any) => params.value,
            align: 'center'
          }
          this.columnDefinitions.push(columnDef)
        }
        if (this.rowData && this.rowData.length > 0 && this.selectedHeadersDetails.length > 0) {
          const headerLabels = this.selectedHeadersDetails.map(h => h.label);
          this.rowData = this.rowData.map(row => {
            headerLabels.forEach(label => {
              if (!(label in row)) {
                row[label] = "";  // add missing field with empty value
              }
            });
            return row;
          });

          console.log(this.rowData);

        }

        this.columnDefs = this.columnDefinitions;
        console.log(this.columnDefs);
        
          
      }
        
    });
  }

  createRecord() {
    let dialogRef = this.dialog.open(CreateRecordsPopupComponent, {
      width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      disableClose: true,
      data: { editData: this.headersDataDetails },
    });

    dialogRef.afterClosed().subscribe(result => {
     
      if (result) {
        let lastIndex = this.rowData.length
        for (let i = 0; i < result.length; i++) {
          result[i].index = lastIndex + i
        }
        console.log(this.rowData);
        console.log(result);
        this.rowData.push(...result)
        // this.rowData=result
        this.gridAPI.api.setGridOption('rowData', this.rowData)
        this.gridAPI.api.hideOverlay();
      }
    });
  }

  async onFileChange(event: any): Promise<void> {
    console.log(event);
    let input = event.target as HTMLInputElement;
    const target: DataTransfer = <DataTransfer>event.target;
    
    const file = input.files[0];
    const fileName = file.name.toLowerCase();
    const allowedExtensions = ['xlsx'];
    const fileExtension = fileName.split('.').pop();

    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      this.snackbar.open(
        "Invalid file type. Please select a Excel (.xlsx) file.",
        "OK",
        { duration: 5000 }
      );
      input.value = '';
      return;
    }

    const reader: FileReader = new FileReader();
    try {

  const jsonData = await this.excelService.readExcelAsMatrix( target.files[0]);
  console.log(jsonData);
      if (jsonData.length > 0) {
        // Extract headers (first row)
        // this.columnDefs = jsonData[0].map((header: string) => ({
        //   headerName: header,
        //   field: header
        // }));
        let headerList = []
        if (this.selectedHeadersDetails.length > 0) {
          console.log(this.selectedHeadersDetails);
          let labelsToRemove = this.selectedHeadersDetails.map(obj => obj.label);
          headerList = jsonData[0].filter(item => !labelsToRemove.includes(item));
        } else {
          headerList = jsonData[0]
        }
        if (headerList.length == 0) {
          let data = jsonData.slice(1).map((row: any[], i: number) => {
            const rowObj: any = { index: i }; // Starts from 0
            jsonData[0].forEach((key: string, index: number) => {
              rowObj[key] = row[index] !== undefined ? row[index] : '';
            });
            return rowObj;
          });
          this.rowData.push(...data)
          this.gridAPI.api.setGridOption('rowData', this.rowData)
          this.gridAPI.api.hideOverlay();
        } else {
          // Extract row data (remaining rows)
          // this.rowData = jsonData.slice(1).map(row => {
          //   let rowObj: any = {};
          //   jsonData[0].forEach((key: string, index: number) => {
          //     rowObj[key] = row[index] || '';
          //   });
          //   return rowObj;
          // });
          if (this.selectedHeadersDetails.length > 0) {
            // alert("The headers appear to be mismatched. Kindly update them to match correctly.")
            this.snackbar.open(
              "The headers appear to be mismatched. Kindly update them to match correctly.",
              "OK",
              { duration: 5000 }
            );
          } else {
            this.rowData = jsonData.slice(1).map((row: any[], i: number) => {
              const rowObj: any = { index: i }; // Starts from 0
              jsonData[0].forEach((key: string, index: number) => {
                rowObj[key] = row[index] !== undefined ? row[index] : '';
              });
              return rowObj;
            });
            console.log(this.rowData);
            // 
            let dialogRef = this.dialog.open(CreateHeaderPopupComponent, {
              width: "70%",
              autoFocus: false,
              maxWidth: '100vw',
              height: "85%",
              disableClose: true,
              data: { headerList: headerList },
            });
        
            dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              // this.onGridReady(this.gridApi);
              if (result) {
                if (this.selectedHeadersDetails.length > 0) {
                  console.log(this.selectedHeadersDetails);
                  console.log(result);
                  this.selectedHeadersDetails.push(...result)
                } else {
                  this.selectedHeadersDetails = result
                }
                this.headersDataDetails.SourceColumns = []
                this.headersDataDetails.TargetColumns = []
                this.columnDefinitions = []
                let actionButtons = {
                  headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
                  pinned: 'left',
                  lockPinned: true,
                  cellRendererParams: {
                    edit: this.EditIcon.bind(this),
                    delete: this.deleteIcon.bind(this),
                    onCheckboxChange: this.checkIcon.bind(this)
                  }, width: 150
                }
                this.columnDefinitions.push(actionButtons)
                for (let i = 0; i < this.selectedHeadersDetails.length; i++) {
         
                  if (this.selectedHeadersDetails[i].sourceOrTarget == "Source") {
                    let headerObject = {
                      "label": this.selectedHeadersDetails[i].label,
                      "datatype": this.selectedHeadersDetails[i].datatype,
                      "sourceOrTarget": this.selectedHeadersDetails[i].sourceOrTarget,
                      "keyOrder": this.selectedHeadersDetails[i].keyOrder,
                      "isMandatory": this.selectedHeadersDetails[i].isMandatory
                    }
                    this.headersDataDetails.SourceColumns.push(headerObject)
                  } else {
                    let headerObject = {
                      "label": this.selectedHeadersDetails[i].label,
                      "datatype": this.selectedHeadersDetails[i].datatype,
                      "sourceOrTarget": this.selectedHeadersDetails[i].sourceOrTarget,
                      "keyOrder": this.selectedHeadersDetails[i].keyOrder,
                      "isMandatory": this.selectedHeadersDetails[i].isMandatory
                    }
                    this.headersDataDetails.TargetColumns.push(headerObject)
                  }
                }
                console.log(this.headersDataDetails);
                for (let i = 0; i < this.headersDataDetails.SourceColumns.length; i++) {
                  let columnDef = {
                    headerName: this.headersDataDetails.SourceColumns[i].label,
                    field: this.headersDataDetails.SourceColumns[i].label,
                    width: 180,
                    filter: true,
                    suppressToolPanel: true,
                    headerTooltip: this.headersDataDetails.SourceColumns[i].label,
                    tooltipValueGetter: (params: any) => params.value,
                    align: 'center'
                  }
                  this.columnDefinitions.push(columnDef)
                }
                for (let i = 0; i < this.headersDataDetails.TargetColumns.length; i++) {
                  let columnDef = {
                    headerName: this.headersDataDetails.TargetColumns[i].label,
                    field: this.headersDataDetails.TargetColumns[i].label,
                    width: 180,
                    filter: true,
                    cellStyle: { backgroundColor: '#a0b4c34a' },
                    headerClass: 'header-cyan',
                    suppressToolPanel: true,
                    headerTooltip: this.headersDataDetails.TargetColumns[i].label,
                    tooltipValueGetter: (params: any) => params.value,
                    align: 'center'
                  }
                  this.columnDefinitions.push(columnDef)
                }
                this.columnDefs = []
                this.columnDefs = this.columnDefinitions;
                console.log(this.columnDefs);
                if (this.rowData.length > 0) {
                  this.gridAPI.api.setGridOption('rowData', this.rowData)
                  this.gridAPI.api.hideOverlay();
                } else {
                  this.gridAPI.api.setGridOption('rowData', [])
                  this.gridAPI.api.showNoRowsOverlay();
                }
       
              }
            });
          }
        }
      }
    
} catch (error) {

  console.error(error);

  this.snackbar.open(
    "Unable to read Excel file",
    "OK",
    { duration: 5000 }
  );

}
    input.value = '';
  }

  createMapping() {
    
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
      if (this.buttonName == 'Create Mapping') {

        console.log(this.headersDataDetails);
        console.log(this.rowData);
        this.spinner.start();
        let dnsId = this.localStorageSettings.getSettings("dnsName");
        let valueMappingData = {
          "mappingTypeId": this.selectedMappingType,
          "mappedFields": JSON.stringify(this.headersDataDetails),
          "mappedFieldsData": JSON.stringify(this.rowData),
          "tenantId": dnsId
        
        }
        this.service.createFieldMapping(valueMappingData).subscribe(response => {
          if (response.error == true) {
            this.spinner.stop();
            this.getdata = null
            console.log(this.getdata)
            this.gridAPI.api.setGridOption('rowData', this.getdata)
            this.gridAPI.api.hideOverlay();
            this.columnDefs = [];
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          } else {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
            this.onMappingTypeSelectionChange()
            console.log(response);
            this.spinner.stop();
          }
        })
      } else {
        console.log(this.headersDataDetails);
        console.log(this.rowData);
        this.spinner.start();
        let dnsId = this.localStorageSettings.getSettings("dnsName");
        let valueMappingData = {
          "mappingTypeId": this.selectedMappingType,
          "mappedFields": JSON.stringify(this.headersDataDetails),
          "mappedFieldsData": JSON.stringify(this.rowData),
          "tenantId": dnsId,
          "fieldMappingId": this.getdata.fieldMappingId
        
        }
        this.service.createFieldMapping(valueMappingData).subscribe(response => {
          if (response.error == true) {
            this.spinner.stop();
            this.getdata = null
            console.log(this.getdata)
            this.gridAPI.api.setGridOption('rowData', this.getdata)
            this.gridAPI.api.hideOverlay();
            this.columnDefs = [];
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          } else {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
            this.onMappingTypeSelectionChange()
            console.log(response);
            this.spinner.stop();
          }
        })
      }
      // createFieldMapping
    }
  }

  validation_messages = {
    mappingType: [
      {
        type: 'required',
        message: 'Library selection is required.'
      }
    ]
  };
  cancel() {
    this.rowData = [];
    this.getdata = []
    this.columnDefs = [];
    this.columnDefinitions = []
    this.selectedMappingType = ""
    this.headersDataDetails = {
      "SourceColumns": [],
      "TargetColumns": []
    }
    this.gridAPI.api.setGridOption('rowData', [])
    this.gridAPI.api.showNoRowsOverlay();
    this.columnDefinitions = []
    this.selectedHeadersDetails = []
    this.buttonName = "Create Mapping"
    this.validations_form.reset()
  }

  getRouterLink(event): any[] {
    if (event.label === 'Objects') {
      return ['/user/Menubar/trnxBaseComponent'];
    } else {
      return [`/user/Menubar/${event.link}`];
    }
  }

  getQueryParams(label: string): any {
    if (label === 'Objects') {
      return {
        screenType: 'Dynamic/Transactions',
        tableName: 'objectmetadata',
        headerNameHtml: 'Objects'
      };
    }
    return null;
  }
  checkIcon(event) {
    console.log(event);
    const id = event.rowData.index;
    const index = this.selectedValueMappingIndexs.indexOf(id);
    if (event.checked) {
      this.selectedValueMappingIndexs.push(id)
    } else {
      this.selectedValueMappingIndexs.splice(index, 1);
    }
    console.log(this.selectedValueMappingIndexs);
  
  }

  deleteSelectedList() {
    if (confirm("Are you sure you want to delete selected mappings ?")) {
      this.rowData = this.rowData.filter(
        (item) => !this.selectedValueMappingIndexs.includes(item.index)
      );
      //  this.gridAPI.api.setGridOption('rowData', this.rowData)
      // Clear the selected indices after deletion
  
      console.log(this.headersDataDetails);
      console.log(this.rowData);
      this.spinner.start();
      let dnsId = this.localStorageSettings.getSettings("dnsName");
      let valueMappingData = {
        "mappingTypeId": this.selectedMappingType,
        "mappedFields": JSON.stringify(this.headersDataDetails),
        "mappedFieldsData": JSON.stringify(this.rowData),
        "tenantId": dnsId,
        "fieldMappingId": this.getdata.fieldMappingId
        
      }
      this.service.createFieldMapping(valueMappingData).subscribe(response => {
        if (response.error == true) {
          this.spinner.stop();
          this.getdata = null
          console.log(this.getdata)
          this.gridAPI.api.setGridOption('rowData', this.getdata)
          this.gridAPI.api.hideOverlay();
          this.columnDefs = [];
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        } else {
          this.snackbar.open("Record deleted successfully.", "OK", {
            duration: 5000,
          });
          this.onMappingTypeSelectionChange()
          console.log(response);
          this.selectedValueMappingIndexs = [];
          this.spinner.stop();
        }
      })
    }
  }
  
  importData() {
     
    console.log("<--- Inside upload Group Template --->")
    let width = "85%";
    let dialogRef = this.dialog.open(ImportJsonComponent, {
      maxWidth: "70vw",
      height: "50%",
      width: width,
      data: { "tablename": this.importExportTableName },
      disableClose: true,
    });
      
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      
      //this.reportCreationData = result;
      
      //this.vaultObjectService.retrieveobjectgroup();
    });
      
      
  }
    
  
  async exportData() {
    this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
    let tenantid = localStorage.getItem("dnsName")
     
  
    try {
      const blob = await this.commonService.downloadJsonFile(this.importExportTableName, tenantid);
      const link = document.createElement('a');
      const timestamp = new Date().getTime();
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.importExportTableName}_export_${timestamp}.json`;
      link.click();
      window.URL.revokeObjectURL(link.href);
  
    } catch (error) {
      console.error('Error downloading JSON:', error);
    }
      
      
  }
   
  

  hasPermission() {
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {
        
        this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }
       
      this.buttonIdList.push('screen');
      console.log('Button ID List:', this.buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!this.buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
      });
 
    });
  }


  //  /**
  //  * @Author DARSHAN NAGARAJ
  //  * @Date 05-05-2026
  //  * @Desc Ensures mandatory  headers are added to source/target only if missing, using case-insensitive checks to prevent duplicates.
  //  */

addMandatoryHeadersIfMissing() {
  const mandatoryHeaders = this.constants.CODELIST_MANDATORY_HEADERS;

  // helper (local or reuse existing one)
  const normalize = (val: string) => val?.trim().toLowerCase();

  mandatoryHeaders.forEach(header => {

    const existsInSource = this.headersDataDetails.SourceColumns
      .some(col => normalize(col.label) === normalize(header.label));

    const existsInTarget = this.headersDataDetails.TargetColumns
      .some(col => normalize(col.label) === normalize(header.label));

    if (!existsInSource && !existsInTarget) {

      const headerObj = {
        label: header.label,
        datatype: 'String',
        sourceOrTarget: header.sourceOrTarget,
        keyOrder: header.keyOrder,
        isMandatory: true
      };

      if (header.sourceOrTarget === 'Source') {
        this.headersDataDetails.SourceColumns.push(headerObj);
      } else {
        this.headersDataDetails.TargetColumns.push(headerObj);
      }
    }
  });
}
}


